
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"inherit","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill-rule":"nonzero","cx":"12","cy":"12","r":"12"}}),_c('path',{attrs:{"fill":"#F2F4F8","d":"M17.588 6l1.82 1.82L9.16 18.07 4 12.909l1.82-1.82 3.34 3.34z"}})])])
          )
        }
      }
    